import React from 'react';
import Flex from '../../Flex/Flex';
import { CreateProps } from '../../../types/utils/CreateProps';
import SmallText from '../../Typography/SmallText/SmallText';
import Icon from '../../Icon/Icon';
import Div from '../../Element/Div/Div';
import styles from './CardInfo.module.scss';
import CardColorVariants, {
  CardColorVariantsProps,
} from '../CardColorVariants/CardColorVariants';

export type CardInfoProps = CreateProps<
  {
    /** Product rating which is displayed on the left side, use null for not available */
    rating?: string | null;
    /** Product number */
    productNumber?: string;
  } & Partial<CardColorVariantsProps>,
  typeof Flex
>;

const CardInfo: React.FunctionComponent<CardInfoProps> = ({
  rating,
  productNumber,
  colorVariants,
  className,
  ...props
}) => {
  return (
    <Flex
      className={[styles.cardInfo, className]}
      alignBaseline
      spaceBetween
      occupyVerticalSpace={false}
      {...props}
    >
      {rating !== undefined && (
        <Div>
          <Flex centeredVertically>
            <Icon
              margin={{ right: 'xxs' }}
              name="star"
              color={rating ? 'orange500' : 'gray400'}
              size="xs"
            />
            <SmallText
              className={styles.cardInfo_text}
              size="sm"
              color="gray500"
            >
              {rating || '-'}
            </SmallText>
          </Flex>
        </Div>
      )}

      {colorVariants && <CardColorVariants colorVariants={colorVariants} />}

      {productNumber && !colorVariants && (
        <SmallText
          size="sm"
          color="gray500"
          className={styles.cardInfo_productNumber}
        >
          {productNumber}
        </SmallText>
      )}
    </Flex>
  );
};

export default CardInfo;
